import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import FormFiller from "@/components/FormFiller";
import { GraduationCap, Eye } from "lucide-react";

const day = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "");

export function HrTrainingRecords({ employeeId }) {
  const [d, setD] = useState({ forms: [], records: [] });
  const [formId, setFormId] = useState("");
  const [open, setOpen] = useState(null);
  const load = useCallback(() => {
    api.get("/hr/training-records", { params: { employee_id: employeeId || "", form_id: formId } }).then((r) => setD(r.data)).catch(() => setD({ forms: [], records: [] }));
  }, [employeeId, formId]);
  useEffect(() => { load(); }, [load]);
  if (!d.forms.length) { return null; }
  return (
    <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-4" data-testid="hr-training-records">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-slate-900"><GraduationCap className="h-4 w-4 text-indigo-500" />Training records{employeeId ? "" : " (all staff)"}</h2>
        <select value={formId} onChange={(e) => setFormId(e.target.value)} className="h-8 rounded-lg border border-slate-200 px-2 text-xs" data-testid="hr-training-form-filter">
          <option value="">All training forms</option>
          {d.forms.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      </div>
      {d.records.length ? (
        <ul className="mt-3 divide-y divide-slate-100">
          {d.records.map((s) => (
            <li key={s.id} className="flex items-center justify-between gap-3 py-2 text-sm" data-testid={`hr-training-${s.id}`}>
              <span className="min-w-0 truncate"><b className="font-medium text-slate-800">{s.answers?.trn_trainee || s.submitted_by}</b> · {s.form_name} · <span className="text-emerald-700">Signed {day(s.submitted_at)} · locked</span></span>
              <button onClick={() => setOpen(s)} className="inline-flex h-7 items-center gap-1 rounded-lg border border-slate-200 px-2 text-xs hover:bg-slate-50" data-testid={`hr-training-view-${s.id}`}><Eye className="h-3.5 w-3.5" />View</button>
            </li>))}
        </ul>
      ) : <p className="mt-3 text-sm text-slate-400" data-testid="hr-training-empty">No signed training records yet.</p>}
      {open && <FormFiller submission={open} locked onClose={() => setOpen(null)} />}
    </div>
  );
}
